import { rem } from "@certn/cascadia";
import { GhostButton, GridItem, Text } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { css } from "@emotion/css";
import { useField } from "formik";
import { useState } from "react";
import { Trans } from "react-i18next";

import { ConvictionModal } from "./ConvictionModal";
import { ConvictionsList } from "./ConvictionsList";
import { WhatToDeclareModal } from "./WhatToDeclareModal";
import { Conviction } from "./type";

type ConvictionsCheckField = components["schemas"]["ConvictionsCheckField"];

export function ConvictionInputField({
  field: config,
}: {
  field: ConvictionsCheckField;
}) {
  const [field, , helpers] = useField<ConvictionsCheckField["value"]>(
    config.name
  );
  const [convictions, setConvictions] = useState<Conviction[]>(
    field.value.map((a, index) => ({ ...a, index }))
  );

  const handleSaveConviction = (conviction: Conviction) => {
    const newConvictions = convictions;
    newConvictions[conviction.index] = conviction;
    setConvictions(newConvictions);
    helpers.setValue(newConvictions);
  };

  const handleDeleteConviction = (index: number) => {
    const newConvictions = convictions.filter((_, i) => index !== i);
    setConvictions(newConvictions);
    helpers.setValue(newConvictions);
  };

  return (
    <>
      <GridItem>
        <Text as="h2" style="form/section-heading">
          <Trans>Criminal convictions</Trans>
        </Text>
        <Text
          style="form/body-secondary"
          className={css({ marginTop: rem("space-2") })}
          color="text-weak"
        >
          <Trans>
            Any crimes you have been convicted of that have not been pardoned.
          </Trans>{" "}
          <WhatToDeclareModal />
        </Text>
      </GridItem>

      {convictions.length > 0 && (
        <ConvictionsList
          testID="conviction-input-field-convictions-list"
          convictions={convictions}
          onSave={handleSaveConviction}
          onDelete={handleDeleteConviction}
        />
      )}

      <GridItem className={css({ display: "block" })}>
        <ConvictionModal
          index={convictions.length}
          onSave={handleSaveConviction}
          trigger={
            <GhostButton
              testID="conviction-input-field-conviction-modal-button"
              leftIcon="add"
              size="medium"
              fill="background-base"
              border="border-strong"
            >
              <Trans>Add conviction</Trans>
            </GhostButton>
          }
        />
      </GridItem>
    </>
  );
}
